const createFullUserName = (firstName, lastName) =>
  firstName && lastName ? `${firstName} ${lastName}` : 'N/A'

export default createFullUserName
